<template>
    <div
        class="relative"
        ref="wrapper"
    >
        <button
            class="action-button"
            @click.prevent="toggle"
        >
            <span
                class="action-button-icon"
                v-html="sortIcon"
            ></span>

            <span class="action-button-label">
                Sort
            </span>
        </button>

        <Transition>
            <Dropdown
                v-if="options.length"
                class="w-full"
                placement="5xl-right"
                v-model:active="active"
            >
                <ul class="leading-none flex flex-col space-y-1.5 sm:space-y-2.5">
                    <li
                        v-for="option in options"
                        :key="option.slug"
                    >
                        <label
                            :for="`option-${option.slug}`"
                            class="flex items-center gap-2.5 text-xsss sm:text-xs"
                        >
                            <input
                                :id="`option-${option.slug}`"
                                class="radio"
                                type="radio"
                                name="sort"
                                :value="option.slug"
                                :checked="props.selected == option.slug"
                                @change="() => emit('change', option.slug)"
                            >
                            <span
                                class="pt-1"
                                v-html="option.label"
                            ></span>
                        </label>
                    </li>
                </ul>
            </Dropdown>
        </Transition>
    </div>
</template>

<script setup>
    import sortIcon from '@img/icons/sort.svg?raw';

    import { ref, computed, onMounted, useTemplateRef, watch } from 'vue';

    import Dropdown from '@js/src/components/Dropdown.vue';

    const props = defineProps([
        'type',
        'selected',
    ]);

    const emit = defineEmits(['change']);

    const wrapper = useTemplateRef('wrapper');

    const options = computed(() => {
        let options = [
            { slug: 'relevance', label: 'Relevance' },
            { slug: 'price_high', label: 'Price: High to Low' },
            { slug: 'price_low', label: 'Price: Low to High' },
        ];

        if (props?.type == 'stays') {
            options.push(
                { slug: 'guests_high', label: 'Guests: High to Low' },
                { slug: 'guests_low', label: 'Guests: Low to High' },
                { slug: 'bedrooms_high', label: 'Bedrooms: High to Low' },
                { slug: 'bedrooms_low', label: 'Bedrooms: Low to High' },
            );
        } else if (props?.type == 'weddings') {
            options.push(
                { slug: 'capacity_high', label: 'Venue capacity: High to Low' },
                { slug: 'capacity_low', label: 'Venue capacity: Low to High' },
                { slug: 'seating_high', label: 'Seating: High to Low' },
                { slug: 'seating_low', label: 'Seating: Low to High' },
            );
        }

        options.push(
            { slug: 'title_asc', label: 'A to Z' },
            { slug: 'title_desc', label: 'Z to A' },
        );

        return options;
    });
    const active = ref(false);

    function toggle() {
        active.value = !active.value;
    }

    watch(() => props.selected, (newValue) => {
        toggle();
        emit('change', newValue);
    });

    onMounted(() => {
        window.addEventListener('click', function (e) {
            if (wrapper.value && !wrapper.value.contains(e.target)) {
                active.value = false;
            }
        });
    });
</script>
